import styled from 'styled-components';

const RatingText = styled.span`
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${props => props.color};
`;

export default RatingText;
